import { NativeModules } from 'react-native';

const AndroidLog = NativeModules.AndroidLog;

class AndroidLogModule {
  static init(): Promise<string> {
    return AndroidLog ? AndroidLog.init() : Promise.resolve();
  }

  static d(content: string) {
    return AndroidLog && AndroidLog.d(content);
  }

  static i(content: string) {
    return AndroidLog && AndroidLog.i(content);
  }

  static w(content: string) {
    return AndroidLog && AndroidLog.w(content);
  }

  static e(content: string) {
    return AndroidLog && AndroidLog.e(content);
  }
}

export default AndroidLogModule;
